import { Navigate, Outlet, useOutletContext } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import CollectionsBootstrap from 'modules/documents/lib/EmployeesCollectionsBootstrap'
import type { RouteContext } from 'modules/employees/lib/types'
import type Employee from 'modules/employees/store/models/Employee'

const isAuthorized = (employee: Employee): boolean => {
  return (
    employee.policy.can('readDocuments') ||
    users.current.policy.can('documents.employeeManageAnyEmployeeFolder')
  )
}

const Container = () => {
  const { navigation } = useNavigation()
  const context = useOutletContext<RouteContext>()
  const { employee } = context

  if (!!employee && !isAuthorized(employee)) {
    return (
      <Navigate replace to={navigation.employees.id.fullPath({ id: employee.attributes.id })} />
    )
  }

  return <Outlet context={context} />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
